import React, { memo } from 'react';
import { Breadcrumb } from 'antd';
import { useBreadcrumb } from '@/shared/hooks/useBreadcrumb';
import { layoutStyles } from '@/shared/styles/layoutStyles';
import { type BreadcrumbItem } from '@/shared/lib/breadcrumb-context';

interface AppBreadcrumbProps {
  customBreadcrumbs?: BreadcrumbItem[] | null;
}

export const AppBreadcrumb: React.FC<AppBreadcrumbProps> = memo(({ customBreadcrumbs }) => {
  const { breadcrumbItems } = useBreadcrumb();
  
  return (
    <Breadcrumb 
      items={customBreadcrumbs || breadcrumbItems}
      style={layoutStyles.breadcrumb}
    />
  );
});

AppBreadcrumb.displayName = 'AppBreadcrumb';